import { useMemo, useContext } from 'react';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Button } from 'foundations-components/transitional/components/Button';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { NUM_FIRST_OPTIONS_SHOWN } from '../constants/OptionsTable';
import { clearPreselected } from './utils/clearPreselected';
import TrackingContext from 'ui-forms-components/contextProviders/TrackingContext';
import { FIELD_OPTIONS } from 'ui-forms-components/constants/TrackingEvents';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const OptionsTableFooter = ({
  formField,
  optionsLength = 0,
  shouldShowMore = false,
  shouldShowLess = false,
  shouldShowClear = false,
  handleUpdate = () => {},
  toggleShowMore = () => {}
}) => {
  const {
    track
  } = useContext(TrackingContext);
  const showMoreButton = useMemo(() => shouldShowMore && !shouldShowLess && optionsLength > NUM_FIRST_OPTIONS_SHOWN, [shouldShowMore, shouldShowLess, optionsLength]);
  const showLessButton = useMemo(() => shouldShowLess && optionsLength > NUM_FIRST_OPTIONS_SHOWN, [shouldShowLess, optionsLength]);
  const onClearPreselected = () => {
    clearPreselected(formField, handleUpdate);
    track(FIELD_OPTIONS.CLEARED_PRESELECTED);
  };
  return /*#__PURE__*/_jsxs(TFlex, {
    justify: "between",
    align: "center",
    children: [showMoreButton && /*#__PURE__*/_jsx(Button, {
      use: "link",
      onClick: toggleShowMore,
      "data-test-id": "options-table-show-more",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "options.showMore"
      })
    }), showLessButton && /*#__PURE__*/_jsx(Button, {
      use: "link",
      onClick: toggleShowMore,
      "data-test-id": "options-table-show-more",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "options.showLess"
      })
    }), shouldShowClear && /*#__PURE__*/_jsx(Button, {
      use: "link",
      onClick: onClearPreselected,
      "data-test-id": "options-table-show-more",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "options.clearPreselected"
      })
    })]
  });
};
export default OptionsTableFooter;